<template>
	<div  class=" no-record" v-if="type == 'chart'">
		<img src="../../../../static/website/images/No-found.svg" />
	    <p>Sorry! No Record</p>
	</div>
	<div class="internalLoder" v-else-if="type == 'complete'">
		<div class="pageloader_value" >
			<div class="noData loader-info no_data" >
				<p class="text-center">
				<!-- <img src="../../../../static/website/images/no-record-icon.png" alt="Icon"> -->
				<img src="../../../../static/website/images/No-found.svg" alt="Icon">
				<span class="oops">oops!</span> there is no record
			   </p>
			</div>
		</div>
	</div>
		<tr class="internalLoder" v-else-if="type == 'table'">
			<td class="pageloader_value" :colspan="colspan">
				<div class="inno-record">
					<div :colspan="colspan">
						<div class="noData text-center">
							<img src="../../../../static/website/images/No-found.svg" alt="Icon"> 
							<p class="text-center"><span class="oops">oops!</span> there is no record</p>
						</div>
					</div>
				</div>
			</td>
		</tr>
</template>
<script>
	export default {
		name: 'NO-RECORD',
		data() {
			return { }
		},
		props:{
			'type': {
			    default: 'complete',
			},
			'colspan' : {
			    default: '',
			},
			'page' : {
			    default: '',
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/no_record.vue